import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Autoplay } from "swiper/modules";
import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import searchListMain, { parentChildCheckbox } from "@/js/components/others/_search-list.js";

const topPickup = () => {
    const pickupSwiper = document.querySelector(".pg-home-banner__swiper");
    if (!pickupSwiper) return;

    new Swiper(pickupSwiper, {
        modules: [Autoplay],
        slidesPerGroup: 1,
        slidesPerView: 1.6,
        spaceBetween: 16,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        loop: true,
        // centeredSlides: true,
        breakpoints: {
            1024: {
                slidesPerView: 5,
            },
        },
    });
};

const setSearchArea = () => {
    const setAreaSearchCountAction = (type) => {
        const areaSearchCountAction = new CountAction(document.querySelector(`.pg-home-area-search-area-list__block[data-mode="${type}"] [data-pickup-search]`));
        areaSearchCountAction.on('countChange', (e) => {
            const target = document.querySelector('.pg-home-area-search [data-pickup-count]');
            countUpAction(target, e.count);
            if (e.count == 0) {
                document.querySelector('.pg-home-area-search__count').dataset.empty = '';
                document.querySelectorAll('.pg-home-area-search__buttons button').forEach(button => button.setAttribute('disabled', ''));
            } else {
                delete document.querySelector('.pg-home-area-search__count').dataset.empty;
                document.querySelectorAll('.pg-home-area-search__buttons button').forEach(button => button.removeAttribute('disabled'));
            }
            parentChildCheckbox();
        });
    }

    const PgHomeAreaSearch = document.querySelector(".pg-home-area-search select");
    if (!PgHomeAreaSearch) return;

    document.querySelector('.pg-home-area-search select').addEventListener('change', (e) => {
        const selectedType = e.currentTarget.value;
        document.querySelector('.pg-home-area-search__count').dataset.empty = '';
        document.querySelectorAll('.pg-home-area-search__buttons button').forEach(button => button.setAttribute('disabled', ''));
        document.querySelector('.pg-home-area-search__count [data-pickup-count]').innerText = '0';
        document.querySelectorAll('.pg-area-search-area-list__block input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false;
        });
        document.querySelectorAll('.pg-home-area-search__buttons button').forEach(button => button.setAttribute('form', `area-search-form-${selectedType}`));
        document.querySelectorAll('.pg-home-area-search-area-list__block').forEach(block => {
            if (block.dataset.mode === selectedType) {
                block.dataset.isShow = '';
            } else {
                delete block.dataset.isShow;
            }
        });
    });
    document.querySelector('.pg-home-area-search__type select').dispatchEvent(new Event('change'));

    ["mansion", "land", "house"].forEach(type => {
        setAreaSearchCountAction(type);
    });
    searchListMain();
}

const main = () => {
    topPickup();
    setSearchArea();
}

export default main
